import 'es6-promise/auto';
import './bootstrap';
import 'waypoints/lib/jquery.waypoints';
import 'lazysizes';
import './page';

window.Tawk_API = window.Tawk_API || {};
window.Tawk_LoadStart = new Date();
window.Tawk_API.onLoad = function() {
    console.log('load')
    var statusDiv_id = 'status-tawkto';
    var pageStatus = window.Tawk_API.getStatus();

    if (pageStatus === 'online') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-success">En Linea</span>';
    } else if (pageStatus === 'away') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-warning">Ocupado</span>';
    }
};
window.Tawk_API.onStatusChange = function(status) {
    console.log('status-change', { status })
    var statusDiv_id = 'status-tawkto';
    if (status === 'online') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-success">En Linea</span>';
    } else if (status === 'away') {
        document.getElementById(statusDiv_id).innerHTML = 'El Chat en Vivo está <span class="badge badge-warning">Ocupado</span>';
    }
};
window.Tawk_API.onOfflineSubmit = function(data) {
    const url = '/api/contacto/offline-submit';

    window.axios.post(url, data)
        .then(console.log)
        .catch(console.error);
};
window.Tawk_API.onPrechatSubmit = function(data) {
    console.log("PRECHAT", data);
}

$(document).ready(function () {
    var $animate = $("[data-animate]");
    if ($animate.length > 0) {
        //Check if jQuery Waypoint plugin is loaded
        if (typeof Waypoint === "undefined") {
            console.warn("jQuery Waypoint plugin is missing in plugins.js file.");
            return true;
        }
        $animate.each(function() {
            var elem = $(this);
            elem.addClass("animate__animated");
            //Plugin Options
            elem.options = {
                animation: elem.attr("data-animate") || "animate__fadeIn",
                delay: elem.attr("data-animate-delay") || 200,
                direction: ~elem.attr("data-animate").indexOf("Out")
                ? "back"
                : "forward",
                offsetX: elem.attr("data-animate-offsetX") || 0,
                offsetY: elem.attr("data-animate-offsetY") || -100
            };
            //Initializing jQuery Waypoint plugin and passing the options from data animations attributes
            if (elem.options.direction == "forward") {
                new Waypoint({
                    element: elem,
                    handler: function() {
                        var t = setTimeout(function() {
                        elem.addClass(elem.options.animation + " visible");
                        }, elem.options.delay);
                        this.destroy();
                    },
                    offset: "100%"
                });
            } else {
                elem.addClass("visible");
                elem.on("click", function() {
                elem.addClass(elem.options.animation);
                return false;
                });
            }
        });
    }
});
